export default __webpack_public_path__ + "static/media/October2008.011c8e78.png";